import React, { ReactNode } from "react";
import { useMediaQuery } from "../../../hooks/useMediaQuery";

interface ResponsiveContainerProps {
  children: ReactNode;
  className?: string;
  mobilePadding?: string;
  desktopPadding?: string;
  maxWidth?: string;
}

export const ResponsiveContainer: React.FC<ResponsiveContainerProps> = ({
  children,
  className = "",
  mobilePadding = "px-4 py-4",
  desktopPadding = "px-6 py-6",
  maxWidth = "max-w-7xl",
}) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <div
      className={`
        w-full 
        mx-auto 
        ${maxWidth}
        ${isMobile ? mobilePadding : desktopPadding}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default ResponsiveContainer;
